export default __webpack_public_path__ + "static/media/resendMail.124f17ad.svg";